export function isDev(): boolean {
  return (
    process.env.VUE_APP_LOCAL === 'true' ||
    location.origin.includes('webuidev.azureedge.net') ||
    location.origin.includes('webuisit.azureedge.net')
  )
}

export function getQueryParameterKey(): string {
  const urlParams = new URLSearchParams(window.location.search)
  const items = ['bankdaten-aendern', 'adresse-aendern', 'name-aendern', 'notfound']
  for (let i = 0; i < items.length; i++) {
    const value = urlParams.get(items[i])
    if (value === '') {
      return items[i]
    }
  }
  return 'notfound'
}
